import { Dialog, Box, FormLabel, FormControl, styled } from '@mui/material';

import DraggablePaper from '../DraggablePaper';

const DialogStyled = styled(Dialog, {
  shouldForwardProp: (prop) => prop !== 'width',
})<{ width?: string }>(({ width }) => ({
  '& .MuiDialog-paper': {
    maxWidth: width || 600,
    width: width || 'auto',
    maxHeight: '85vh',
    display: 'flex',
    flexDirection: 'column',
  },
  '& .react-draggable': {
    backgroundColor: 'white',
    border: 0,
    outline: 'none',
    borderRadius: '8px',
  },
  '& .MuiDialogContent-root': {
    padding: 0,
    flex: 1,
    overflow: 'hidden',
  },
  // Ensure dialog is centered when it opens
  '& .MuiDialog-scrollPaper': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

interface DialogGlyntProps {
  children: React.ReactNode;
  width?: string;
  open: boolean;
  closeModal: () => void;
  startIcon?: React.ReactNode;
  loading?: boolean;
  cypressId: string;
}

export const FormLabelStyled = styled(FormLabel)({
  fontSize: '12px',
  fontWeight: 600,
  lineHeight: '20px',
  letterSpacing: '0px',
  color: '#333',
  marginBottom: '4px',
});

export const FormControlStyled = styled(FormControl)({
  marginTop: '14px',
  width: '100%',
});

const DialogGlynt: React.FC<DialogGlyntProps> = ({
  children,
  width = '500px',
  open,
  closeModal,
  loading = false,
  cypressId,
}) => {
  return (
    <DialogStyled
      key={open ? 'open' : 'closed'}
      width={width}
      open={open}
      keepMounted={false}
      PaperProps={{ id: cypressId }}
      onClose={(e, reason) => {
        if (reason !== 'backdropClick' && !loading) {
          closeModal();
        }
      }}
      aria-labelledby="draggable-dialog-title"
      PaperComponent={DraggablePaper}
      data-cy={cypressId}
    >
      {children}
    </DialogStyled>
  );
};

export default DialogGlynt;
